"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const transforms_1 = require("@nteract/transforms");
const immutable_1 = require("immutable");
const output_1 = __importDefault(require("./output"));
exports.DEFAULT_SCROLL_HEIGHT = 600;
class Display extends React.PureComponent {
    render() {
        const _a = this.props, { isHidden, outputs } = _a, props = __rest(_a, ["isHidden", "outputs"]);
        if (!isHidden) {
            return (React.createElement("div", { className: "cell_display", style: {
                    maxHeight: props.expanded ? "100%" : `${exports.DEFAULT_SCROLL_HEIGHT}px`,
                    overflowY: "auto"
                } }, outputs
                ? outputs.map((output, index) => (React.createElement(output_1.default, Object.assign({ key: index, index: index, output: output }, props))))
                : null));
        }
        return null;
    }
}
Display.defaultProps = {
    transforms: transforms_1.transforms,
    displayOrder: transforms_1.displayOrder,
    isHidden: false,
    expanded: false,
    theme: "light",
    models: immutable_1.Map()
};
exports.default = Display;
